<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div v-if="loading">
			<spinner-component :loading="loading"/>
		</div>

		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div v-else class="row justify-content-center">
			<div v-if="!loading" class="col-md-6 mb-5">
				<alert-success :form="form" :class="'shadow-sm'" message="Your changes have been saved!"></alert-success>

				<h3 class="tx-color-01">Alerts for your portfolio value</h3>
				<p class="tx-color-03 mg-b-30">The alerts are calculated daily on the basis of the portfolio value supplied by the custodian bank.</p>

				<form class="row" method="POST" action="/api/user/portfolio/warning" @submit.prevent="save">
					<div class="form-group col-md-6">
						<label>Notification at</label>
						<select v-model="form.notify_when" class="form-control custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('notify_when') }">
							<option selected :value="null" disabled>Select an option</option>
							<option v-for="(notify_when, index) in notification_types" :value="notify_when.value" :key="index">{{ notify_when.name }}</option>
						</select>
						<has-error :form="form" field="notify_when"></has-error>
					</div>
					<div class="form-group col-md-6">
						<label>Value</label>
						<div class="input-group shadow-sm">
							<a href="#change-currency" data-toggle="modal">
								<div class="input-group-prepend value">
									<span class="input-group-text">{{ form.currency|placeholder('Select currency') }}</span>
								</div>
							</a>
							<input v-model="form.value" type="number" class="form-control" :class="{ 'is-invalid': form.errors.has('value') }" placeholder="0.00" required>
						</div>
						<has-error :form="form" field="value" :class="'d-block'"></has-error>
					</div>
					<div class="col-12 mt-3">
						<button-component :busy="form.busy" :label="'Save'" :label-loading="'Saving changes...'" :button-class="'btn btn-default float-right mt-3 shadow-sm'"></button-component>
					</div>
				</form>

				<change-currency-component :backdrop="false" :currency="form.currency" @change-currency="changeCurrency"></change-currency-component>
			</div>
        </div>
	</div>
</template>

<style scoped>
	.value .input-group-text {
		border-radius: 0rem;
		border-top-left-radius: 0.25rem;
		border-bottom-left-radius: 0.25rem;
		min-height: 2.4rem;
		/* background: url("data:image/svg+xml,%3csvg xmlns=http://www.w3.org/2000/svg viewBox=0 0 4 5%3e%3cpath fill=%233b4863 d=M2 0L0 2h4zm0 5L0 3h4z/%3e%3c/svg%3e")
			no-repeat right 0.625rem center/8px 10px; */
	}
</style>

<script>
	export default {
		data() {
			return {
				notification_types: this.$store.getters.notification_types,
				loading: false,
				warning: null,
				error: null,
				form: new Form({
					notify_when: null,
					value: null,
					currency: null,
					user: this.$store.getters.company.external_client_id,
				}),
			};
		},
		created() {
			this.fetchPortfolioWarning();
		},
		watch: {
			$route: "fetchPortfolioWarning",
		},
		methods: {
			fetchPortfolioWarning() {
				this.error = this.warning = null;
				this.loading = true;

				axios
					.get("/api/user/portfolio/warning", {
						params: {
							noAllocation: true,
						},
					})
					.then((response) => {
						this.warning = response.data.data.warning;

						if (this.warning) {
							this.form.fill({
								notify_when: this.warning.notify_when,
								value: this.warning.value,
								currency: this.warning.currency,
								user: this.$store.state.company
									.external_client_id,
							});
						}
					})
					.catch((error) => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			},
			save() {
				this.form
					.post("/api/user/portfolio/warning")
					.then(({ data }) => {});
			},
			changeCurrency(currency) {
				this.form.currency = currency;
			},
		},
	};
</script>
